import { useLayoutEffect, useState } from "react";
import { useLocation } from "react-router";

const useMainNavigationPulseAnimation = () => {
  const location = useLocation();
  const [isPulsing, setIsPulsing] = useState(false);

  useLayoutEffect(() => {
    // Trigger pulse animation immediately when location changes
    setIsPulsing(true);

    // Remove pulse class after animation completes
    const timer = setTimeout(() => {
      setIsPulsing(false);
    }, 600);

    return () => clearTimeout(timer);
  }, [location.pathname]);

  return isPulsing;
};

export default useMainNavigationPulseAnimation;
